import {Alert, Table} from "react-bootstrap";
import {Link, useNavigate} from "react-router";
import {SupportApi} from "../../api/SupportApi";
import {useAsync} from "../../components/useAsync";
import {ErrorAlert} from "../../components/ErrorAlert";
import {LoadingSpinner} from "../../components/LoadingSpinner";
import {PageHeader} from "../../components/PageHeader";
import {formatDateTime} from "../../components/format";
import {SupportStateBadge} from "./SupportParts";
import {support} from "../../i18n";

// The signed-in user's support tickets, newest activity first.
export function SupportTicketsPage() {
    const navigate = useNavigate();
    const {data: tickets, error, loading} = useAsync(() => SupportApi.getAll(), []);

    return (
        <>
            <PageHeader title={support.title}>
                <Link to="/support/new" className="btn btn-primary"><i className="bi bi-plus-lg me-1" aria-hidden="true"></i>{support.newTicket}</Link>
            </PageHeader>
            <p className="text-body-secondary">{support.intro}</p>
            {loading && !tickets && <LoadingSpinner/>}
            <ErrorAlert error={error}/>
            {tickets?.length === 0 && <Alert variant="secondary">{support.none}</Alert>}
            {!!tickets?.length && (
                <Table responsive hover>
                    <thead>
                    <tr><th>{support.columns.subject}</th><th>{support.columns.product}</th><th>{support.columns.status}</th><th>{support.columns.lastActivity}</th></tr>
                    </thead>
                    <tbody>
                    {tickets.map(ticket => (
                        <tr key={ticket.id} className="clickable-row" onClick={() => navigate(`/support/${ticket.id}`)}>
                            <td><Link to={`/support/${ticket.id}`} onClick={e => e.stopPropagation()}>{ticket.subject}</Link></td>
                            <td>{ticket.licenseId ? ticket.productName : support.generalTicket}</td>
                            <td><SupportStateBadge state={ticket.state}/></td>
                            <td>{formatDateTime(ticket.lastActivityOn)}</td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            )}
        </>
    );
}
